import { createAction } from 'redux-actions';
export var SET_SAGA_REQUEST_ERRORS = 'SET_SAGA_REQUEST_ERRORS';
export var setSagaRequestErrors = createAction(SET_SAGA_REQUEST_ERRORS);
